var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-left",
      staticStyle: {
        color: "var(--body-color) !important",
        "font-size": "var(--body-size) !important"
      }
    },
    [
      _c("div", { staticClass: "row-format gap-3" }, [
        _c("div", [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.item.description) } }),
          _vm.tokens.get("Item.DueDate")
            ? _c("div", { staticClass: "font-14" }, [
                _vm._v(_vm._s(_vm.tokens.get("Item.DueDate")))
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          {
            staticClass: "pl-2",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _vm.item.setQuantity
              ? _c("v-select", {
                  staticClass: "select",
                  attrs: {
                    items: _vm.quantityRange,
                    outlined: "",
                    dense: "",
                    disabled: _vm.quantityDisabled
                  },
                  model: {
                    value: _vm.item.quantity,
                    callback: function($$v) {
                      _vm.$set(_vm.item, "quantity", $$v)
                    },
                    expression: "item.quantity"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ml-auto text-right column-format item-price" },
          [
            _c("span", { staticStyle: { "font-weight": "600" } }, [
              _vm._v(_vm._s(_vm.tokens.get("Item.Total")))
            ]),
            _vm.item.taxable && _vm.item.quantity && _vm.item.rate
              ? _c("span", { staticClass: "font-14" }, [
                  _vm._v(
                    "+" +
                      _vm._s(_vm.tokens.get("Item.TaxRate")) +
                      " " +
                      _vm._s(
                        _vm.tokens.get("Item.TaxLabel") ||
                          _vm.$t("invoice.details.tax")
                      )
                  )
                ])
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }